import Image from "next/image";
import Link from "next/link";
import React from "react";

/*import "./PostCardImg.scss";*/

interface PostCardImgProps {
  post: {
    featuredImage: string;
    link: string;
  };
  priority: boolean;
}

const PostCardImg = ({
  post: { featuredImage, link },
  priority,
}: PostCardImgProps) => (
  <Link className="card-img" href={link}>
    {featuredImage && (
      <span className="card-img__media">
        <Image
          src={featuredImage}
          alt="Featured"
          width={0}
          height={0}
          sizes="100vw"
          unoptimized
          priority={priority}
          loading={priority ? "eager" : undefined}
        />
      </span>
    )}
  </Link>
);

export default PostCardImg;
